import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Link,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { Suspense, useState } from "react";
import type {
  AssetsAdvertGroupRowDetail
} from "../../../../api/rest/generated/aPIForPublicPartOfApplicationInzerceNemovitéhoMajetku.schemas.ts";
import { useGetApiAssetsadvertId } from "../../../../api/rest/generated/assets-advert/assets-advert.ts";
import { iframeDetailRedirect } from "../../../../utills/iframeDetailRedirect.ts";

const AdGroupInfoSectionFallback: React.FC = () => {
  return (
    <>
      <Skeleton/>
      <Skeleton/>
      <Skeleton/>
      <Skeleton/>
    </>
  );
};

const AdGroupInfoBox: React.FC<{
  adGroupSiblings: AssetsAdvertGroupRowDetail[];
}> = ({adGroupSiblings}) => {
  return (
    <>
      <Typography>Toto vozidlo je možné zakoupit pouze v souboru s:</Typography>
      <Table
        size="small"
        sx={{
          borderCollapse: "collapse",
          margin: "auto",
          "@container ad-detail (max-width: 400px)": {
            margin: 0,
          },
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell sx={{
              border: 'none',
              padding: 0,
              paddingLeft: '1rem',
            }}>
              <ul style={{
                padding: '0'
              }}>
                {adGroupSiblings.map((ad) => {
                  const adName = ad.name || "Název inzerátu není k dispozici";
                  const handleRedirect = () => {
                    iframeDetailRedirect(ad.id);
                  };
                  return (
                    <li
                      key={ad.id}
                      style={{
                        padding: '.25rem 0',
                        textAlign: 'left',
                      }}
                    >
                      <Link
                        sx={{
                          textAlign: 'left',
                          color: "info.main",
                          backgroundColor: 'none !important',

                          // textDecoration: "underline",
                          "&:hover": {
                          //   textDecoration: "none",
                            backgroundColor: 'transparent !important',
                          },

                          // regular underline is kinda ugly
                          // textDecoration: "none",
                          // "&:after": {
                          //   'content': "''",
                          //   'height': '1px',
                          //   'width': '100%',
                          //   'display': 'block',
                          //   'background': 'var(--mui-palette-info-main)',
                          //   'position': 'absolute',
                          //   'bottom': '.35rem',
                          //   'left': '0',
                          // },
                          // "&:hover:after": {
                          //   opacity: 0
                          // }
                        }}
                        component={Button}
                        size="small"
                        color="inherit"
                        onClick={handleRedirect}
                      >
                        {ad.id} - {adName}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

const AdGroupInfoSection: React.FC<{ id: number }> = ({id}) => {
  const [ expandedAdGroupInfo, setExpandedAdGroupInfo ] = useState<boolean>(true);

  const adDetail =
    useGetApiAssetsadvertId(id, {
      query: {
        staleTime: 0,
        select: (data) => {
          return data.assetsAdvertGroupRowDetail;
        },
      },
    })?.data ?? [];

  return adDetail.length > 0 ? (
    <Accordion expanded={expandedAdGroupInfo}>
      <Tooltip
        followCursor={true}
        placement="right"
        title={expandedAdGroupInfo ? "Skrýt informace o prodeji v souboru" : "Zobrazit informace o prodeji v souboru"}
      >
        <AccordionSummary
          onClick={() => setExpandedAdGroupInfo(!expandedAdGroupInfo)}
          sx={{backgroundColor: "grey.200"}}
          expandIcon={<ExpandMore fontSize="medium" color="secondary"/>}
        >
          <Typography fontWeight="bolder" sx={{color: "info.main"}} variant="subtitle1" component="div">
            Prodej v souboru
          </Typography>
        </AccordionSummary>
      </Tooltip>
      <AccordionDetails>
        <Suspense fallback={<AdGroupInfoSectionFallback/>}>
          <AdGroupInfoBox adGroupSiblings={adDetail}/>
        </Suspense>
      </AccordionDetails>
    </Accordion>
  ) : (
    <></>
  );
};

export default AdGroupInfoSection;
